import { type ReactNode } from 'react';
import LanguagePicker from '#common/components/LanguagePicker.tsx';
import { MonochromeCrispyVoiceLogo } from '#common/components/MonochromeCrispyVoiceLogo.js';

export default function LoginLayout(
    { children, title, baseUrl }: { children: React.ReactNode; title: ReactNode; baseUrl: string },
) {
    return (
        <div className='flex h-full'>
            <div className='h-full flex-[2] hidden lg:block bg-[url(/images/loginBackground.webp)] bg-cover bg-center bg-no-repeat'>
            </div>
            <div className='flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 bg-white dark:bg-gray-900 relative'>
                <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
                    <MonochromeCrispyVoiceLogo className='mx-auto h-20 dark:text-crispyblue-500 text-crispyblue-700' />
                    <h2 className='mt-5 text-center text-2xl/9 font-bold tracking-tight text-gray-900 dark:text-white'>
                        {title}
                    </h2>
                </div>

                <div className='mt-10 sm:mx-auto sm:w-full sm:max-w-xl'>{children}</div>
                <LanguagePicker
                    className='absolute left-0 right-0 bottom-8 text-center font-bold text-gray-700 dark:text-white'
                    baseUrl={baseUrl}
                />
            </div>
        </div>
    );
}
